import React from 'react';
import usageIcon from 'src/assets/images/icons/usage-icon.svg';
import moneySendIcon from 'src/assets/images/icons/money-send.svg';
import moneyTickIcon from 'src/assets/images/icons/money-tick.svg';
import moneyTimeIcon from 'src/assets/images/icons/money-time.svg';

interface CreditSummaryCardProps {
  title: string;
  icon: string;
  invoiceValue: number;
  shipmentValue: number;
  gradientColor: string;
}

export const CreditSummaryCard: React.FC<CreditSummaryCardProps> = ({ title, icon, invoiceValue, shipmentValue, gradientColor }) => {
  return (
    <div
      className='relative overflow-hidden bg-white border border-[#DFDFDF] rounded-[6px] px-12 py-10 flex-1 flex flex-col gap-y-6'
      style={{
        boxShadow: '0px 4px 7px 0px rgba(112,149,221,0.12), 0px 1px 0px 0px #DFDFDF',
      }}
    >
      {/* Decorative blur ellipse — top-right corner */}
      <div className='absolute -right-[47px] -top-[85px] w-[120px] h-[98px] rounded-full' style={{ backgroundColor: gradientColor, filter: 'blur(45px)' }} />

      {/* Header row */}
      <div className='flex items-center justify-between border-b border-[#DFDFDF] pb-6'>
        {/* Icon + Title */}
        <div className='flex items-center gap-4 w-[65px]'>
          <img src={icon} alt='' className='w-24 h-24 shrink-0' />
          <span className='font-medium text-[#202020] text-[12px] leading-[1.7] whitespace-nowrap'>{title}</span>
        </div>

        {/* Column labels */}
        <div className='flex flex-1 items-center'>
          <div className='flex-1 flex items-center justify-center'>
            <span className='text-10 text-[#808080] leading-[1.6]'>Invoice</span>
          </div>
          <div className='w-[1px] h-[10px] bg-[#DFDFDF] shrink-0' />
          <div className='flex-1 flex items-center justify-center'>
            <span className='text-10 text-[#808080] leading-[1.6]'>Shipment</span>
          </div>
        </div>
      </div>

      {/* Data row */}
      <div className='flex items-center justify-between'>
        {/* Label */}
        <div className='w-[65px] shrink-0'>
          <span className='text-[10px] text-[#808080] leading-[16px]'>Credits:</span>
        </div>

        {/* Values */}
        <div className='flex flex-1 items-center'>
          <div className='flex-1 flex items-center justify-center'>
            <span className='text-[10px] font-bold text-[#36454F] leading-[1.6]'>{invoiceValue}</span>
          </div>
          <div className='w-[1px] h-[10px] bg-[#DFDFDF] shrink-0' />
          <div className='flex-1 flex items-center justify-center'>
            <span className='text-[10px] font-bold text-[#36454F] leading-[1.6]'>{shipmentValue}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const CARD_CONFIGS: CreditSummaryCardProps[] = [
  {
    title: 'Usage',
    icon: usageIcon,
    invoiceValue: 404,
    shipmentValue: 100,
    gradientColor: 'rgba(247,152,36,0.70)',
  },
  {
    title: 'Billed',
    icon: moneySendIcon,
    invoiceValue: 0,
    shipmentValue: 0,
    gradientColor: 'rgba(68,118,246,0.70)',
  },
  {
    title: 'Paid',
    icon: moneyTickIcon,
    invoiceValue: 0,
    shipmentValue: 0,
    gradientColor: 'rgba(22,173,137,0.70)',
  },
  {
    title: 'Outstanding',
    icon: moneyTimeIcon,
    invoiceValue: 14404,
    shipmentValue: 11100,
    gradientColor: 'rgba(231,37,71,0.70)',
  },
];

export const CreditSummaryCards: React.FC = () => {
  return (
    <div className='flex gap-16'>
      {CARD_CONFIGS.map((config) => (
        <CreditSummaryCard key={config.title} {...config} />
      ))}
    </div>
  );
};
